<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <canvas
        id="myChartDevolucaoOrcadoVendedores"
        width="500"
        height="350"
      />
      <div
        v-if="exibirLegenda"
        id="legendaDevolucaoOrcadoVendedores"
        class="text-center px-12"
      >
        <v-row
          align="center"
          class="ma-0"
        >
          <v-avatar
            class="mr-1"
            color="#00897B"
            size="10"
          />
          <span class="mr-3 font-weight-light">% Devolução</span>
          <v-avatar
            class="mr-1"
            color="#C62828"
            size="10"
          />
          <span class="mr-3 font-weight-light">% Orçado Devolução</span>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Comercial from '../../../../services/comercialpersonalizacao'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardFaturamentoPrecoMedio',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      cores: [],
      myChart: {},
      selectResumo: [],
      selectMes: [],
      selectAno: [],
      selectSupervisor: [],
      exibirLegenda: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      montarGrafico: true,
      loading: false,
      error: null,
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (selectResumo, selectMes, selectAno, selectSupervisor) {
        this.selectResumo = selectResumo
        this.selectMes = selectMes
        this.selectAno = selectAno
        this.selectSupervisor = selectSupervisor

        this.exibirLegenda = false

        this.porcentagem = []
        this.colors = []
        this.cores = []

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Comercial.showGraficoDevolucaoOrcadoVendedores(this.selectResumo, this.selectMes, this.selectAno, this.selectSupervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            var mobile = !(window.innerWidth < 600)

            this.exibirLegenda = true

            const ctx = document.getElementById('myChartDevolucaoOrcadoVendedores').getContext('2d')

            this.myChart = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Orçado Devolução',
                    data: resposta.data.orcado,
                    backgroundColor: '#C62828',
                    order: 2,
                  },
                  {
                    label: 'Devolução',
                    data: resposta.data.porcentagemDevolucao,
                    backgroundColor: '#00897B',
                    order: 1,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: mobile,
                    color: function (context) {
                      if (context.dataset.label !== 'Porcentagem') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 14,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
                    },
                    rotation: 270,
                    align: 'end',
                    offset: 4,
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      beginAtZero: true,
                      minRotation: 90, // Gira os rótulos
                      min: 0,
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
                      } else if (tooltipItem.datasetIndex === 1) {
                        return ['Faturamento: ' + resposta.data.faturamento[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                                'Devolução: ' + resposta.data.devolucao[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                                'Porcentagem devolução: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%']
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - Orçado'
                      } else {
                        return tooltipItem[0].xLabel + ' - Devolução'
                      }
                    },
                  },
                  titleFontSize: 16,
                  bodyFontSize: 16,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {
    #myChartDevolucaoOrcadoVendedores {
      width: 350px !important;
      height: 250px !important;
    }

    #legendaDevolucaoOrcadoVendedores {
      margin: 2rem 0 0 1rem !important;
    }

  }

  @media screen
  and (min-width: 1380px) {
    #myChartDevolucaoOrcadoVendedores {
      width: 1185px !important;
      height: 829px !important;
    }
  }
</style>

<style lang="sass">
  #myChartDevolucaoOrcadoVendedores
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    width: 800px !important
    height: 500px !important

  #legendaDevolucaoOrcadoVendedores
    margin: 3rem 0 0 10rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
</style>
